export type ThemePreference = 'light' | 'dark' | 'system';

export const THEME_STORAGE_KEY = 'yoda-theme';

export const THEME_OPTIONS: ThemePreference[] = ['light', 'dark', 'system'];

export function normalizeTheme(value?: string | null): ThemePreference {
    if (value === 'light' || value === 'dark' || value === 'system')
        return value;
    return 'system';
}

export function prefersDarkSystem(): boolean {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function')
        return false;
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

export function resolveIsDark(theme: ThemePreference): boolean {
    if (theme === 'dark')
        return true;
    if (theme === 'light')
        return false;
    return prefersDarkSystem();
}

export function applyThemeClass(theme: ThemePreference): void {
    if (typeof document === 'undefined')
        return;
    document.documentElement.classList.toggle('dark', resolveIsDark(theme));
}

export function readStoredTheme(): ThemePreference {
    try {
        return normalizeTheme(localStorage.getItem(THEME_STORAGE_KEY));
    } catch {
        return 'system';
    }
}

export function storeTheme(theme: ThemePreference): void {
    try {
        localStorage.setItem(THEME_STORAGE_KEY, normalizeTheme(theme));
    } catch {
        // ignore quota / private mode
    }
}
